import { component } from "picoapp";
import { handleize } from "../lib/utils";

export default component(async (node) => {
  // Options - Options
  const optionElements = node.querySelectorAll("[data-option-radio]");
  const dataFor = node.dataset.eventFor;
  const productHandle = node.dataset.productHandle;

  try {
    const select = node.querySelector(`select#${dataFor}`);
    if (!optionElements || !optionElements.length) return;

    const selectedVariant = () => {
      const checkedRadios = node.querySelectorAll(
        'input[type="radio"]:checked'
      );
      const selectedOptionValues = [...checkedRadios].map((el) => el.value);
      const selectedOption = [...select.options].find((optionElement) => {
        return (
          handleize(optionElement.id) ===
          handleize(selectedOptionValues.join("-"))
        );
      });

      if (!selectedOption) {
        return null;
      } else {
        const selectInput = node.querySelector("select[data-option-main]");
        const variantId = selectedOption.value;
        selectInput.value = variantId;
        return { id: variantId, options: selectedOptionValues };
      }
    };

    optionElements.forEach((option) => {
      const radios = option.querySelectorAll('input[type="radio"]');
      radios.forEach((radio) => {
        radio.addEventListener("click", (e) => {
          const { value } = e.target;
          const variant = selectedVariant();
          const variantSelectedEvent = new CustomEvent(
            `variant-selected:${dataFor}`,
            {
              detail: {
                product: productHandle,
                variant: variant ? variant.id : null,
                options: variant ? variant.options : null,
                lastClickedOption: value,
              },
            }
          );
          window.dispatchEvent(variantSelectedEvent);
        });
      });
    });
  } catch (error) {
    console.error(error);
  }
});
